import { A11yModule } from '@angular/cdk/a11y';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SimDateModule } from '@ngx-simple/core/datetime';
import { SimButtonModule } from '@ngx-simple/simple-ui/button';
import { SimIconModule } from '@ngx-simple/simple-ui/icon';
import { SimInputModule } from '@ngx-simple/simple-ui/input';
import { SimCalendarBodyComponent } from './calendar-body.component';
import { SimCalendarHeaderComponent } from './calendar-header.component';
import { SimCalendarComponent } from './calendar.component';
import { SimDateRangeInputComponent } from './date-range-input.component';
import { SimEndDateDirective, SimStartDateDirective } from './date-range-input.directive';
import { SimDateRangePickerComponent, SimDateRangePickerContentComponent } from './date-range-picker.component';
import { DefaultSimCalendarRangeStrategy, SIM_DATE_RANGE_SELECTION_STRATEGY } from './date-range-selection-strategy';
import { SIM_DATEPICKER_SCROLL_STRATEGY_FACTORY_PROVIDER } from './datepicker-base';
import { SimDatepickerInputDirective } from './datepicker-input.directive';
import { SimDatepickerToggleComponent, SimDatepickerToggleIconDirective } from './datepicker-toggle.component';
import { SimDatepickerComponent, SimDatepickerContentComponent } from './datepicker.component';
import { SimMonthViewComponent } from './month-view.component';
import { SimMultiYearViewComponent } from './multi-year-view.component';
import { SimTimeItemListDirective, SimTimeViewComponent } from './time-view.component';
import { SimWeekViewComponent } from './week-view.component';
import { SimYearViewComponent } from './year-view.component';

@NgModule({
  declarations: [
    SimDatepickerComponent,
    SimCalendarComponent,
    SimDatepickerContentComponent,
    SimCalendarHeaderComponent,
    SimDatepickerInputDirective,
    SimYearViewComponent,
    SimCalendarBodyComponent,
    SimMonthViewComponent,
    SimMultiYearViewComponent,
    SimDateRangePickerComponent,
    SimStartDateDirective,
    SimEndDateDirective,
    SimDateRangePickerContentComponent,
    SimDateRangeInputComponent,
    SimTimeViewComponent,
    SimTimeItemListDirective,
    SimWeekViewComponent,
    SimDatepickerToggleIconDirective,
    SimDatepickerToggleComponent
  ],
  imports: [CommonModule, SimDateModule, A11yModule, OverlayModule, PortalModule, SimButtonModule, SimIconModule],
  exports: [
    SimDatepickerComponent,
    SimDatepickerInputDirective,
    SimStartDateDirective,
    SimEndDateDirective,
    SimDateRangePickerComponent,
    SimDateRangeInputComponent,
    SimInputModule,
    SimDatepickerToggleIconDirective,
    SimDatepickerToggleComponent
  ],
  providers: [
    SIM_DATEPICKER_SCROLL_STRATEGY_FACTORY_PROVIDER,
    {
      provide: SIM_DATE_RANGE_SELECTION_STRATEGY,
      useClass: DefaultSimCalendarRangeStrategy
    }
  ],
  entryComponents: [SimDatepickerContentComponent]
})
export class SimDatepickerModule {}
